import React from 'react';
import CurrencyInput from 'react-currency-input';
import InputMask from 'react-input-mask';
import { TextValidator } from 'react-material-ui-form-validator';

const percentageFields = [
    ['percentual_ff_cobranca', 'Percentual FF mensalidade/anuidade'],
    ['percentual_ff_site', 'Percentual FF site'],
    ['percentual_ff_oferta_autos', 'Percentual FF Oferta Autos'],
    ['percentual_ff_custo_cobranca', 'Percentual FF custo cobrança'],
    ['percentual_ff_bot', 'Percentual FF bot'],
];

const moneyFields = [
    ['valor_cobranca', 'Valor mensalidade/anuidade'],
    ['valor_site', 'Valor site'],
    ['valor_mensalidade_oferta_autos', 'Valor mensalidade Oferta Autos'],
    ['valor_mensalidade_bot', 'Valor mensalidade bot'],
];

function CurrencyField({ name, label, value, percentage, disabled, onChange }) {
    return (
        <div className="col-lg-4">
            <div className="form-group">
                <label>{label}</label><br/>
                <CurrencyInput
                    onChangeEvent={onChange}
                    label={label}
                    name={name}
                    value={value}
                    className="form-ui-bootstrap"
                    decimalSeparator=","
                    thousandSeparator={percentage ? "" : "."}
                    precision="2"
                    prefix={percentage ? "" : "R$ "}
                    suffix={percentage ? " %" : ""}
                    disabled={disabled}
                />
            </div>
        </div>
    );
}

export default function ParametrosCobranca({ values, onChange, onCurrencyChange }) {
    return (
        <div className="panel panel-default billing-parameters">
            <div className="panel-heading"><strong>Parâmetros de cobrança</strong></div>
            <div className="panel-body">
                <div className="row">
                    <div className="col-lg-4">
                        <div className="form-group">
                            <label>Status cobrança</label>
                            <select className="form-ui-bootstrap" name="status_cobranca" onChange={onChange} value={values.status_cobranca}>
                                <option value=""></option>
                                <option value="ativo">Ativo</option>
                                <option value="teste">Em teste</option>
                                <option value="suspenso">Suspenso</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="form-group">
                            <label>Período cobrança</label>
                            <select className="form-ui-bootstrap" name="periodo_cobranca" onChange={onChange} value={values.periodo_cobranca}>
                                <option value=""></option>
                                <option value="mensal">Mensal</option>
                                <option value="anual">Anual</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="form-group">
                            <label>Possui site</label>
                            <select className="form-ui-bootstrap" name="possui_site" onChange={onChange} value={values.possui_site}>
                                <option value=""></option>
                                <option value="sim">Sim</option>
                                <option value="nao">Não</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-4">
                        <div className="form-group">
                            <TextValidator
                                label="Dia cobrança *"
                                onChange={onChange}
                                name="dia_cobranca"
                                value={values.dia_cobranca}
                                className="form-ui-bootstrap"
                                validators={['required', 'minNumber:1', 'maxNumber:28', 'matchRegexp:^[0-9]+$']}
                                errorMessages={['Preenchimento obrigatório', 'Informe um dia entre 1 e 28', 'Informe um dia entre 1 e 28', 'Informe um número inteiro']}
                            />
                        </div>
                    </div>
                    {values.periodo_cobranca === 'anual' && (
                        <div className="col-lg-4">
                            <div className="form-group">
                                <TextValidator
                                    label="Mês cobrança *"
                                    onChange={onChange}
                                    name="mes_cobranca"
                                    value={values.mes_cobranca}
                                    className="form-ui-bootstrap"
                                    validators={['required', 'minNumber:1', 'maxNumber:12', 'matchRegexp:^[0-9]+$']}
                                    errorMessages={['Preenchimento obrigatório', 'Informe um mês entre 1 e 12', 'Informe um mês entre 1 e 12', 'Informe um número inteiro']}
                                />
                            </div>
                        </div>
                    )}
                    <div className="col-lg-4">
                        <div className="form-group">
                            <TextValidator
                                label="Dias para bloqueio por inadimplência"
                                onChange={onChange}
                                name="dias_bloqueio_inadimplencia"
                                value={values.dias_bloqueio_inadimplencia}
                                className="form-ui-bootstrap"
                                validators={['minNumber:0', 'matchRegexp:^$|^[0-9]+$']}
                                errorMessages={['Informe um valor a partir de zero', 'Informe um número inteiro']}
                            />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <CurrencyField name={moneyFields[0][0]} label={moneyFields[0][1]} value={values.valor_cobranca_mask} onChange={onCurrencyChange} />
                    <CurrencyField name={percentageFields[0][0]} label={percentageFields[0][1]} value={values.percentual_ff_cobranca_mask} percentage onChange={onCurrencyChange} />
                </div>

                {values.possui_site === 'sim' && (
                    <div className="row">
                        <CurrencyField name={moneyFields[1][0]} label={moneyFields[1][1]} value={values.valor_site_mask} onChange={onCurrencyChange} />
                        <CurrencyField name={percentageFields[1][0]} label={percentageFields[1][1]} value={values.percentual_ff_site_mask} percentage onChange={onCurrencyChange} />
                    </div>
                )}

                <div className="row">
                    <CurrencyField name={moneyFields[2][0]} label={moneyFields[2][1]} value={values.valor_mensalidade_oferta_autos_mask} onChange={onCurrencyChange} />
                    <CurrencyField name={percentageFields[2][0]} label={percentageFields[2][1]} value={values.percentual_ff_oferta_autos_mask} percentage onChange={onCurrencyChange} />
                </div>

                <div className="row">
                    <CurrencyField name={moneyFields[3][0]} label={moneyFields[3][1]} value={values.valor_mensalidade_bot_mask} onChange={onCurrencyChange} />
                    <CurrencyField name={percentageFields[4][0]} label={percentageFields[4][1]} value={values.percentual_ff_bot_mask} percentage onChange={onCurrencyChange} />
                </div>

                <div className="row">
                    <div className="col-lg-4">
                        <div className="form-group">
                            <TextValidator
                                label="E-mail cobrança *"
                                onChange={onChange}
                                name="email_cobranca"
                                value={values.email_cobranca}
                                className="form-ui-bootstrap"
                                validators={['required', 'isEmail']}
                                errorMessages={['Preenchimento obrigatório', 'E-mail inválido']}
                            />
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="form-group">
                            <InputMask
                                mask="(99) 99999-9999"
                                value={values.whatsapp_cobranca}
                                name="whatsapp_cobranca"
                                onChange={onChange}
                            >
                                {() => <TextValidator
                                    label="WhatsApp cobrança *"
                                    name="whatsapp_cobranca"
                                    type="text"
                                    value={values.whatsapp_cobranca}
                                    className="form-ui-bootstrap"
                                    validators={['required', 'matchRegexp:^\\([0-9]{2}\\) [0-9]{5}-[0-9]{4}$']}
                                    errorMessages={['Preenchimento obrigatório', 'WhatsApp inválido']}
                                />}
                            </InputMask>
                        </div>
                    </div>
                    <CurrencyField name={percentageFields[3][0]} label={percentageFields[3][1]} value={values.percentual_ff_custo_cobranca_mask} percentage disabled onChange={onCurrencyChange} />
                </div>
            </div>
        </div>
    );
}
